import axiosInstance from "./axiosInstance";

export const getChatListApi = (page: number = 1) => {
  const response = axiosInstance.get(`/chats/?page=${page}`);
  return response;
};

export const getChatHistoryApi = (id: number, page: number | null) => {
  const response = axiosInstance.get(`/chats/${id}/?page=${page}`);
  return response;
};

export const sendMessageApi = (id: number, payload: any) => {
  const response = axiosInstance.post(`/chats/${id}/`, payload);
  return response;
};

export const getChatUnreadCountApi = () => {
  const response = axiosInstance.get(`/chats/stats`);
  return response;
};
